import { createContext, useState, useEffect } from "react";
import { validateToken } from "../services/auth.service";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      const storedUser = localStorage.getItem("user");
      const storedToken = localStorage.getItem("token");

      if (storedUser && storedToken) {
        try {
          const isValid = await validateToken(storedToken);

          if (isValid) {
            setUser(JSON.parse(storedUser));
          } else {
            console.warn("Token inválido o expirado. Cerrando sesión...");
            logout();
          }
        } catch (error) {
          console.error("Error validando token:", error);
          logout();
        }
      }

      setLoading(false);
    };

    checkSession();
  }, []);

  const login = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("token", userData.token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
